import Crop from './crop';

function crop(props) {
  return new Crop(props);
}

export default crop;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/crop/index.js
// module id = 553
// module chunks = 9